module.exports = __webpack_public_path__ + "img/mt_clickbait_logo.864eca0f.svg";